// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-section-container {
  display: block;
  max-width: 100%;
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 2rem;
}

.bg-theme {
  background-color: #1397d5 !important;
}

.nav-link.active {
  font-weight: bold;
  border-left: 4px solid var(--primary);
  background-color: #f0f9ff;
}
.nav-link:hover {
  color: var(--primary);
}

.order-card {
  transition: box-shadow 0.3s ease;
}

.order-card:hover {
  box-shadow: 0 0 10px rgba(19, 151, 213, 0.1);
}

/* CSS */
.track-order-btn {
  background: linear-gradient(to left, #0099e5 50%, #007ecc 50%);
  color: #fff;
  border: none;
  font-weight: 600;
  transition: background-position 0.4s ease;
  background-size: 200% 100%;
  background-position: right;
}

.track-order-btn:hover {
  background-position: left;
}

/* Buttons */
.btn.track-order-btn,
.btn-outline-primary {
  background-color: var(--primary);
  border-color: var(--primary);
  color: #fff;
}

.btn-outline-primary:hover {
  background-color: #0b76ac;
  border-color: #0b76ac;
  color: #fff;
}

/* Inputs and selects (borders and focus) */
.form-control:focus,
.form-select:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 0.2rem rgba(19, 151, 213, 0.25);
}

/* Form-check radio input (selected state) */
.form-check-input:checked {
  background-color: var(--primary);
  border-color: var(--primary);
}

/* Pagination */
.pagination .page-link {
  color: var(--primary);
}

.pagination .page-item.active .page-link {
  background-color: var(--primary);
  border-color: var(--primary);
  color: #fff;
}

.pagination .page-link:hover {
  background-color: rgba(19, 151, 213, 0.1);
}

/* tracking order stepper */
.track {
  position: relative;
  background-color: transparent;
  height: 50px;
  display: flex;
  margin: 50px 0;
}
.track .step {
  flex-grow: 1;
  text-align: center;
  position: relative;
  margin-top: -18px;
}
.track .step::before, .track .step::after {
  content: "";
  position: absolute;
  top: 18px;
  height: 7px;
  background-color: #ddd;
  z-index: 0;
}
.track .step:not(:first-child)::before {
  left: 0;
  width: 50%;
}
.track .step:not(:last-child)::after {
  right: 0;
  width: 50%;
}
.track .step.active:not(:first-child)::before {
  background-color: #ff5722;
}
.track .step.active:not(:last-child)::after {
  background-color: #ff5722;
}
.track .step.active .icon {
  background-color: #ff5722;
}
.track .step.active .text {
  color: #000;
  font-weight: 500;
}
.track .step .icon {
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  background: #ddd;
  color: white;
  position: relative;
  z-index: 1;
}
.track .step .text {
  display: block;
  margin-top: 7px;
}

/* Issue with Order Dialog Styles */
.issue-dialog :deep(.p-dialog) .p-dialog-header {
  background-color: #fff3cd;
  border-bottom: 2px solid #ffc107;
}

.issue-dialog-content .card-header h5 {
  color: #856404;
  margin: 0;
}
.issue-dialog-content .title-icon {
  color: var(--primary);
  font-weight: 600;
}
.issue-dialog-content .issue-products-list {
  max-height: 300px;
  overflow-y: auto;
  border-radius: 0.375rem;
}
.issue-dialog-content .issue-products-list .issue-product-item {
  padding: 12px;
  border-radius: 0.375rem;
  transition: all 0.3s ease;
  cursor: pointer;
}
.issue-dialog-content .issue-products-list .issue-product-item:hover {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.issue-dialog-content .issue-products-list .issue-product-item .form-check-input:checked {
  background-color: var(--primary);
  border-color: var(--primary);
}
.issue-dialog-content .issue-products-list .issue-product-item .form-check-label {
  cursor: pointer;
  align-items: center;
}
.issue-dialog-content .issue-products-list .issue-product-item .issue-product-img {
  flex-shrink: 0;
}
.issue-dialog-content .issue-products-list .issue-product-item .issue-product-info {
  padding-left: 0.5rem;
}
.issue-dialog-content .form-control:focus,
.issue-dialog-content .form-label:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 0.2rem rgba(19, 151, 213, 0.25);
}
.issue-dialog-content .btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive adjustments for issue dialog */
@media (max-width: 768px) {
  .issue-dialog :deep(.p-dialog) {
    width: 95% !important;
  }
  .issue-dialog-content .issue-products-list {
    max-height: 250px;
  }
  .issue-dialog-content .form-control,
  .issue-dialog-content textarea {
    font-size: 16px;
  }
}
/* Conversation Thread Dialog Styles */
.conversation-dialog :deep(.p-dialog) .p-dialog-header {
  background-color: #f0f9ff;
  border-bottom: 2px solid var(--primary);
}

.conversation-container .card-header {
  background-color: #f8f9fa;
}
.conversation-container .card-header h5 {
  color: var(--primary);
  margin: 0;
}
.conversation-container .card-header .badge {
  font-size: 0.875rem;
  padding: 0.5rem 0.75rem;
}
.conversation-container .title-icon {
  color: var(--primary);
  font-weight: 600;
}
.conversation-container .products-list {
  max-height: 200px;
  overflow-y: auto;
  border-radius: 0.375rem;
}
.conversation-container .products-list .last-no-border:last-child {
  border-bottom: none !important;
}
.conversation-container .conversation-messages-wrapper {
  background-color: #fafafa;
  max-height: 500px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.conversation-container .conversation-messages-wrapper .conversation-messages {
  flex: 1;
  overflow-y: auto;
  padding-right: 0.5rem;
}
.conversation-container .conversation-messages-wrapper .conversation-messages::-webkit-scrollbar {
  width: 6px;
}
.conversation-container .conversation-messages-wrapper .conversation-messages::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 3px;
}
.conversation-container .conversation-messages-wrapper .conversation-messages::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}
.conversation-container .conversation-messages-wrapper .conversation-messages::-webkit-scrollbar-thumb:hover {
  background: #999;
}
.conversation-container .conversation-messages-wrapper .message-item.user-message {
  text-align: right;
}
.conversation-container .conversation-messages-wrapper .message-item.user-message .message-header {
  text-align: right;
  padding-right: 0.5rem;
}
.conversation-container .conversation-messages-wrapper .message-item.user-message .message-content {
  background-color: rgba(19, 151, 213, 0.1) !important;
  border-left: 3px solid var(--primary);
  margin-left: auto;
  max-width: 80%;
}
.conversation-container .conversation-messages-wrapper .message-item.admin-message {
  text-align: left;
}
.conversation-container .conversation-messages-wrapper .message-item.admin-message .message-header {
  text-align: left;
  padding-left: 0.5rem;
}
.conversation-container .conversation-messages-wrapper .message-item.admin-message .message-content {
  background-color: #ffffff !important;
  border-left: 3px solid #28a745;
  margin-right: auto;
  max-width: 80%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.conversation-container .conversation-messages-wrapper .message-item .message-content {
  word-wrap: break-word;
  white-space: pre-wrap;
  line-height: 1.5;
}
.conversation-container .input-group {
  gap: 0.5rem;
}
.conversation-container .input-group textarea {
  resize: vertical;
  min-height: 50px;
}
.conversation-container .input-group textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 0.2rem rgba(19, 151, 213, 0.25);
}
.conversation-container .input-group .btn-primary {
  white-space: nowrap;
}
.conversation-container .alert {
  border-radius: 0.375rem;
}

/* Responsive adjustments for conversation dialog */
@media (max-width: 768px) {
  .conversation-dialog :deep(.p-dialog) {
    width: 95% !important;
  }
  .conversation-container .conversation-messages-wrapper {
    max-height: 350px;
  }
  .conversation-container .message-item.user-message .message-content, .conversation-container .message-item.admin-message .message-content {
    max-width: 95%;
  }
  .conversation-container .input-group {
    flex-direction: column;
  }
  .conversation-container .input-group .btn-primary {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/orders/orders.scss"],"names":[],"mappings":"AAWA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AATJ;;AAYA;EACI,oCAAA;AATJ;;AAYI;EACI,iBAAA;EACA,qCAAA;EACA,yBAAA;AATR;AAWI;EACI,qBAAA;AATR;;AAaA;EACI,gCAAA;AAVJ;;AAaA;EACI,4CAAA;AAVJ;;AAaA,QAAA;AACA;EACI,8DAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yCAAA;EACA,0BAAA;EACA,0BAAA;AAVJ;;AAaA;EACI,yBAAA;AAVJ;;AAaA,YAAA;AACA;;EAEI,gCAAA;EACA,4BAAA;EACA,WAAA;AAVJ;;AAaA;EACI,yBAAA;EACA,qBAAA;EACA,WAAA;AAVJ;;AAaA,2CAAA;AACA;;EAEI,4BAAA;EACA,iDAAA;AAVJ;;AAaA,4CAAA;AACA;EACI,gCAAA;EACA,4BAAA;AAVJ;;AAaA,eAAA;AACA;EACI,qBAAA;AAVJ;;AAaA;EACI,gCAAA;EACA,4BAAA;EACA,WAAA;AAVJ;;AAaA;EACI,yCAAA;AAVJ;;AAaA,2BAAA;AAEA;EACI,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AAXJ;AAaI;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAXR;AAaQ;EAEI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;AAZZ;AAgBQ;EACI,OAAA;EACA,UAAA;AAdZ;AAkBQ;EACI,QAAA;EACA,UAAA;AAhBZ;AAqBY;EACI,yBAAA;AAnBhB;AAuBY;EACI,yBAAA;AArBhB;AAwBY;EACI,yBAAA;AAtBhB;AAyBY;EACI,WAAA;EACA,gBAAA;AAvBhB;AA2BQ;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AAzBZ;AA4BQ;EACI,cAAA;EACA,eAAA;AA1BZ;;AA+BA,mCAAA;AAGQ;EACI,yBAAA;EACA,gCAAA;AA9BZ;;AAqCQ;EACI,cAAA;EACA,SAAA;AAlCZ;AAsCI;EACI,qBAAA;EACA,gBAAA;AApCR;AAuCI;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;AArCR;AAuCQ;EACI,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;AArCZ;AAuCY;EACI,sBAAA;EACA,wCAAA;AArChB;AAwCY;EACI,gCAAA;EACA,4BAAA;AAtChB;AAyCY;EACI,eAAA;EACA,mBAAA;AAvChB;AA0CY;EACI,cAAA;AAxChB;AA2CY;EACI,oBAAA;AAzChB;AAgDQ;;EACI,4BAAA;EACA,iDAAA;AA7CZ;AAkDQ;EACI,YAAA;EACA,mBAAA;AAhDZ;;AAqDA,4CAAA;AACA;EAEQ;IACI,qBAAA;EAnDV;EAwDM;IACI,iBAAA;EAtDV;EAyDM;;IAEI,eAAA;EAvDV;AACF;AA2DA,sCAAA;AAGQ;EACI,yBAAA;EACA,uCAAA;AA3DZ;;AAiEI;EACI,yBAAA;AA9DR;AAgEQ;EACI,qBAAA;EACA,SAAA;AA9DZ;AAiEQ;EACI,mBAAA;EACA,uBAAA;AA/DZ;AAmEI;EACI,qBAAA;EACA,gBAAA;AAjER;AAoEI;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;AAlER;AAqEY;EACI,8BAAA;AAnEhB;AAwEI;EACI,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAtER;AAwEQ;EACI,OAAA;EACA,gBAAA;EACA,qBAAA;AAtEZ;AAwEY;EACI,UAAA;AAtEhB;AAyEY;EACI,mBAAA;EACA,kBAAA;AAvEhB;AA0EY;EACI,gBAAA;EACA,kBAAA;AAxEhB;AA0EgB;EACI,gBAAA;AAxEpB;AA8EY;EACI,iBAAA;AA5EhB;AA8EgB;EACI,iBAAA;EACA,qBAAA;AA5EpB;AA+EgB;EACI,oDAAA;EACA,qCAAA;EACA,iBAAA;EACA,cAAA;AA7EpB;AAiFY;EACI,gBAAA;AA/EhB;AAiFgB;EACI,gBAAA;EACA,oBAAA;AA/EpB;AAkFgB;EACI,oCAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,wCAAA;AAhFpB;AAoFY;EACI,qBAAA;EACA,qBAAA;EACA,gBAAA;AAlFhB;AAuFI;EACI,WAAA;AArFR;AAuFQ;EACI,gBAAA;EACA,gBAAA;AArFZ;AAuFY;EACI,4BAAA;EACA,iDAAA;AArFhB;AAyFQ;EACI,mBAAA;AAvFZ;AA2FI;EACI,uBAAA;AAzFR;;AA6FA,mDAAA;AACA;EAEQ;IACI,qBAAA;EA3FV;EAgGM;IACI,iBAAA;EA9FV;EAkGU;IAEI,cAAA;EAjGd;EAqGM;IACI,sBAAA;EAnGV;EAqGU;IACI,WAAA;EAnGd;AACF","sourcesContent":["@import \"https://fonts.googleapis.com/css?family=Open+Sans&display=swap\";\n\n$color_1: #fff;\n$color_2: #000;\n$color_3: #212529;\n$color_4: #ffffff;\n$font-family_1: \"Open Sans\", serif;\n$background-color_1: #eeeeee;\n$background-color_2: #fff;\n$background-color_3: #ddd;\n\n.custom-section-container {\n    display: block;\n    max-width: 100%;\n    padding-left: 25px;\n    padding-right: 25px;\n    padding-top: 2rem;\n}\n\n.bg-theme {\n    background-color: #1397d5 !important;\n}\n.nav-link {\n    &.active {\n        font-weight: bold;\n        border-left: 4px solid var(--primary);\n        background-color: #f0f9ff;\n    }\n    &:hover {\n        color: var(--primary);\n    }\n}\n\n.order-card {\n    transition: box-shadow 0.3s ease;\n}\n\n.order-card:hover {\n    box-shadow: 0 0 10px rgba(19, 151, 213, 0.1);\n}\n\n/* CSS */\n.track-order-btn {\n    background: linear-gradient(to left, #0099e5 50%, #007ecc 50%);\n    color: #fff;\n    border: none;\n    font-weight: 600;\n    transition: background-position 0.4s ease;\n    background-size: 200% 100%;\n    background-position: right;\n}\n\n.track-order-btn:hover {\n    background-position: left;\n}\n\n/* Buttons */\n.btn.track-order-btn,\n.btn-outline-primary {\n    background-color: var(--primary);\n    border-color: var(--primary);\n    color: #fff;\n}\n\n.btn-outline-primary:hover {\n    background-color: #0b76ac;\n    border-color: #0b76ac;\n    color: #fff;\n}\n\n/* Inputs and selects (borders and focus) */\n.form-control:focus,\n.form-select:focus {\n    border-color: var(--primary);\n    box-shadow: 0 0 0 0.2rem rgba(19, 151, 213, 0.25);\n}\n\n/* Form-check radio input (selected state) */\n.form-check-input:checked {\n    background-color: var(--primary);\n    border-color: var(--primary);\n}\n\n/* Pagination */\n.pagination .page-link {\n    color: var(--primary);\n}\n\n.pagination .page-item.active .page-link {\n    background-color: var(--primary);\n    border-color: var(--primary);\n    color: #fff;\n}\n\n.pagination .page-link:hover {\n    background-color: rgba(19, 151, 213, 0.1);\n}\n\n/* tracking order stepper */\n\n.track {\n    position: relative;\n    background-color: transparent;\n    height: 50px;\n    display: flex;\n    margin: 50px 0;\n\n    .step {\n        flex-grow: 1;\n        text-align: center;\n        position: relative;\n        margin-top: -18px;\n\n        &::before,\n        &::after {\n            content: \"\";\n            position: absolute;\n            top: 18px;\n            height: 7px;\n            background-color: #ddd;\n            z-index: 0;\n        }\n\n        // Left connector (skip first)\n        &:not(:first-child)::before {\n            left: 0;\n            width: 50%;\n        }\n\n        // Right connector (skip last)\n        &:not(:last-child)::after {\n            right: 0;\n            width: 50%;\n        }\n\n        &.active {\n            // Left connector line (only if not first-child)\n            &:not(:first-child)::before {\n                background-color: #ff5722;\n            }\n\n            // Right connector line (only if not last-child)\n            &:not(:last-child)::after {\n                background-color: #ff5722;\n            }\n\n            .icon {\n                background-color: #ff5722;\n            }\n\n            .text {\n                color: #000;\n                font-weight: 500;\n            }\n        }\n\n        .icon {\n            display: inline-block;\n            width: 40px;\n            height: 40px;\n            line-height: 40px;\n            border-radius: 50%;\n            background: #ddd;\n            color: white;\n            position: relative;\n            z-index: 1;\n        }\n\n        .text {\n            display: block;\n            margin-top: 7px;\n        }\n    }\n}\n\n/* Issue with Order Dialog Styles */\n.issue-dialog {\n    :deep(.p-dialog) {\n        .p-dialog-header {\n            background-color: #fff3cd;\n            border-bottom: 2px solid #ffc107;\n        }\n    }\n}\n\n.issue-dialog-content {\n    .card-header {\n        h5 {\n            color: #856404;\n            margin: 0;\n        }\n    }\n\n    .title-icon {\n        color: var(--primary);\n        font-weight: 600;\n    }\n\n    .issue-products-list {\n        max-height: 300px;\n        overflow-y: auto;\n        border-radius: 0.375rem;\n\n        .issue-product-item {\n            padding: 12px;\n            border-radius: 0.375rem;\n            transition: all 0.3s ease;\n            cursor: pointer;\n\n            &:hover {\n                background-color: #fff;\n                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n            }\n\n            .form-check-input:checked {\n                background-color: var(--primary);\n                border-color: var(--primary);\n            }\n\n            .form-check-label {\n                cursor: pointer;\n                align-items: center;\n            }\n\n            .issue-product-img {\n                flex-shrink: 0;\n            }\n\n            .issue-product-info {\n                padding-left: 0.5rem;\n            }\n        }\n    }\n\n    .form-control,\n    .form-label {\n        &:focus {\n            border-color: var(--primary);\n            box-shadow: 0 0 0 0.2rem rgba(19, 151, 213, 0.25);\n        }\n    }\n\n    .btn-secondary {\n        &:disabled {\n            opacity: 0.6;\n            cursor: not-allowed;\n        }\n    }\n}\n\n/* Responsive adjustments for issue dialog */\n@media (max-width: 768px) {\n    .issue-dialog {\n        :deep(.p-dialog) {\n            width: 95% !important;\n        }\n    }\n\n    .issue-dialog-content {\n        .issue-products-list {\n            max-height: 250px;\n        }\n\n        .form-control,\n        textarea {\n            font-size: 16px; // Prevents zoom on mobile\n        }\n    }\n}\n\n/* Conversation Thread Dialog Styles */\n.conversation-dialog {\n    :deep(.p-dialog) {\n        .p-dialog-header {\n            background-color: #f0f9ff;\n            border-bottom: 2px solid var(--primary);\n        }\n    }\n}\n\n.conversation-container {\n    .card-header {\n        background-color: #f8f9fa;\n\n        h5 {\n            color: var(--primary);\n            margin: 0;\n        }\n\n        .badge {\n            font-size: 0.875rem;\n            padding: 0.5rem 0.75rem;\n        }\n    }\n\n    .title-icon {\n        color: var(--primary);\n        font-weight: 600;\n    }\n\n    .products-list {\n        max-height: 200px;\n        overflow-y: auto;\n        border-radius: 0.375rem;\n\n        .last-no-border {\n            &:last-child {\n                border-bottom: none !important;\n            }\n        }\n    }\n\n    .conversation-messages-wrapper {\n        background-color: #fafafa;\n        max-height: 500px;\n        overflow: hidden;\n        display: flex;\n        flex-direction: column;\n\n        .conversation-messages {\n            flex: 1;\n            overflow-y: auto;\n            padding-right: 0.5rem;\n\n            &::-webkit-scrollbar {\n                width: 6px;\n            }\n\n            &::-webkit-scrollbar-track {\n                background: #f0f0f0;\n                border-radius: 3px;\n            }\n\n            &::-webkit-scrollbar-thumb {\n                background: #ccc;\n                border-radius: 3px;\n\n                &:hover {\n                    background: #999;\n                }\n            }\n        }\n\n        .message-item {\n            &.user-message {\n                text-align: right;\n\n                .message-header {\n                    text-align: right;\n                    padding-right: 0.5rem;\n                }\n\n                .message-content {\n                    background-color: rgba(19, 151, 213, 0.1) !important;\n                    border-left: 3px solid var(--primary);\n                    margin-left: auto;\n                    max-width: 80%;\n                }\n            }\n\n            &.admin-message {\n                text-align: left;\n\n                .message-header {\n                    text-align: left;\n                    padding-left: 0.5rem;\n                }\n\n                .message-content {\n                    background-color: #ffffff !important;\n                    border-left: 3px solid #28a745;\n                    margin-right: auto;\n                    max-width: 80%;\n                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n                }\n            }\n\n            .message-content {\n                word-wrap: break-word;\n                white-space: pre-wrap;\n                line-height: 1.5;\n            }\n        }\n    }\n\n    .input-group {\n        gap: 0.5rem;\n\n        textarea {\n            resize: vertical;\n            min-height: 50px;\n\n            &:focus {\n                border-color: var(--primary);\n                box-shadow: 0 0 0 0.2rem rgba(19, 151, 213, 0.25);\n            }\n        }\n\n        .btn-primary {\n            white-space: nowrap;\n        }\n    }\n\n    .alert {\n        border-radius: 0.375rem;\n    }\n}\n\n/* Responsive adjustments for conversation dialog */\n@media (max-width: 768px) {\n    .conversation-dialog {\n        :deep(.p-dialog) {\n            width: 95% !important;\n        }\n    }\n\n    .conversation-container {\n        .conversation-messages-wrapper {\n            max-height: 350px;\n        }\n\n        .message-item {\n            &.user-message .message-content,\n            &.admin-message .message-content {\n                max-width: 95%;\n            }\n        }\n\n        .input-group {\n            flex-direction: column;\n\n            .btn-primary {\n                width: 100%;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
